var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _path39, _path40, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransferIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 226,
    viewBox: "0 0 213 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.488 41.6038L116.625 56.4294C125.815 66.0672 137.339 73.1674 150.08 77.0418L160.139 80.1008C184.403 87.4792 201.701 108.926 203.775 134.203C205.967 160.925 190.686 186.015 165.938 196.33L150.454 202.783C127.917 212.177 102.426 211.411 80.4921 200.683L59.6053 190.466C30.6656 176.31 11.8854 147.354 10.7612 115.158L9.55818 80.7038C8.49307 50.1992 32.9335 24.8905 63.4568 24.8905C78.205 24.8905 92.3099 30.9303 102.488 41.6038Z",
    fill: "#237FC0",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.531 219.063L115.852 224.633C124.156 224.943 141.043 225.593 142.157 225.717C143.271 225.84 189.457 203.176 212.41 191.828L203.745 142.311L197.4 132.562L188.735 131.324L186.413 127.301L180.843 120.492L175.581 119.409L172.641 111.362L177.903 105.018L188.735 95.4239L194.46 82.4256L193.223 66.023L185.021 51.3224L168.618 44.5139L157.477 45.597L147.264 51.3224L138.908 62.9279L135.504 70.9746L133.028 81.4973L135.504 86.9134L138.908 89.6988V97.1256L140.765 103.78L144.789 108.113L151.287 109.196C151.906 110.744 153.485 114.055 154.846 114.922C156.207 115.788 155.413 122.297 154.846 125.444L153.145 129.777H144.789L133.028 134.264L127.148 139.37L121.577 150.357L109.043 176.509C109.301 177.592 109.909 179.913 110.281 180.532C110.652 181.151 114.15 182.131 115.852 182.544L113.531 197.863V219.063Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.705 154.584C132.637 155.761 131.734 157.077 131.02 158.495C130.293 159.881 129.658 161.313 129.121 162.782C128.082 165.648 127.264 168.588 126.674 171.577C125.567 177.343 124.904 183.184 124.689 189.05C124.619 190.484 124.572 191.915 124.534 193.333L124.479 195.423C124.479 196.054 124.452 196.698 124.413 197.361C124.296 199.985 124.063 202.787 123.899 205.667C123.694 208.668 123.675 211.679 123.841 214.683C123.942 216.263 124.163 217.833 124.502 219.38C124.818 220.966 125.408 222.485 126.246 223.869C126.692 222.429 127.221 221.016 127.829 219.636C128.413 218.299 129.028 216.993 129.627 215.675C130.841 213.043 132.017 210.373 133.048 207.566C134.134 204.672 134.963 201.689 135.526 198.651C135.659 197.876 135.791 197.058 135.877 196.237L135.993 195.074C136.032 194.686 136.063 194.326 136.091 193.954C136.213 192.465 136.296 190.984 136.34 189.512C136.513 183.69 136.302 177.863 135.709 172.069C135.433 169.193 135.075 166.329 134.698 163.453L134.141 159.104C133.962 157.639 133.807 156.166 133.705 154.584Z",
    fill: "#3E84C5",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.185 163.867C157.5 162.86 158.749 161.825 159.995 160.801L163.687 157.747C166.135 155.728 168.555 153.735 170.987 151.793L174.653 148.914L178.373 146.022C179.611 145.049 180.832 144.084 182.031 143.165C183.23 142.247 184.416 141.379 185.533 140.681C186.436 140.074 187.432 139.62 188.483 139.336C188.83 139.26 189.187 139.239 189.541 139.274C189.924 139.324 190.294 139.442 190.635 139.623C191.68 140.218 192.621 140.978 193.421 141.875C194.402 142.933 195.312 144.054 196.145 145.231C197.904 147.665 199.569 150.324 201.227 153.026C202.884 155.728 204.534 158.491 206.375 161.205C205.996 157.97 205.379 154.768 204.531 151.623C203.7 148.419 202.581 145.297 201.188 142.293C200.443 140.709 199.567 139.19 198.569 137.751C198.025 136.977 197.426 136.244 196.775 135.557C196.057 134.793 195.254 134.113 194.382 133.529C192.325 132.152 189.837 131.563 187.378 131.871C186.264 132.025 185.173 132.318 184.132 132.743C183.223 133.12 182.344 133.564 181.502 134.072C180.004 134.986 178.574 136.004 177.221 137.119C175.918 138.173 174.696 139.254 173.505 140.344C172.906 140.882 172.338 141.441 171.738 141.983C171.139 142.526 170.571 143.119 169.98 143.693C168.812 144.855 167.692 146.057 166.621 147.301C165.551 148.545 164.516 149.821 163.508 151.115C163.026 151.778 162.536 152.433 162.069 153.107C161.602 153.782 161.15 154.464 160.699 155.146C160.247 155.828 159.831 156.538 159.415 157.239C158.998 157.941 158.601 158.662 158.224 159.391C157.452 160.839 156.771 162.334 156.185 163.867Z",
    fill: "#3E84C5",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.023 46.6901C177.65 46.4304 178.191 46.1862 178.693 45.9691C178.953 45.8645 179.187 45.756 179.432 45.6668C179.677 45.5777 179.907 45.4885 180.125 45.4032C180.923 45.1123 181.736 44.8639 182.561 44.659C183.759 44.3598 184.982 44.1639 186.215 44.0738C186.791 44.0026 187.374 44.0026 187.95 44.0738C188.697 44.1668 189.542 44.3063 190.437 44.4614C191.332 44.6164 192.293 44.7831 193.308 44.9459C193.557 44.9885 193.818 45.0311 194.087 45.066C194.355 45.1009 194.612 45.1435 194.884 45.1823L195.709 45.2947C196 45.3238 196.288 45.3782 196.569 45.4575C196.584 45.1384 196.541 44.8192 196.441 44.5156C196.361 44.2234 196.263 43.936 196.149 43.6551C196.04 43.3799 195.92 43.1086 195.787 42.8528C195.655 42.597 195.515 42.3373 195.367 42.0776C194.774 41.0951 194.048 40.1979 193.211 39.4109C192.344 38.588 191.359 37.8982 190.289 37.3643C189.683 37.0605 189.048 36.8177 188.394 36.6395C187.682 36.4458 186.949 36.3391 186.211 36.3216C184.818 36.2896 183.435 36.5604 182.158 37.1154C180.881 37.6703 179.741 38.496 178.817 39.5349C177.961 40.5024 177.338 41.6518 176.996 42.8954C176.631 44.1356 176.641 45.4552 177.023 46.6901Z",
    fill: "#3E84C5",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.337 68.0202C138.76 66.4341 140.271 64.9279 141.862 63.5084C143.408 62.1374 145.051 60.8784 146.777 59.7409L148.08 58.8959C148.524 58.613 148.964 58.3378 149.404 58.0703C150.279 57.5315 151.151 57.0238 152.034 56.5664C152.917 56.109 153.797 55.6788 154.692 55.3144C155.587 54.9501 156.482 54.6361 157.377 54.3687C158.271 54.1112 159.181 53.9131 160.101 53.7757C160.991 53.6317 161.891 53.5527 162.794 53.5392C164.587 53.5116 166.376 53.7307 168.109 54.1904C169.868 54.6295 171.567 55.2803 173.168 56.1284C176.414 57.8307 179.246 60.2215 181.464 63.1325C181.736 63.4929 181.993 63.8612 182.242 64.2333C182.491 64.6054 182.713 64.9775 182.927 65.3728C183.373 66.1643 183.771 66.981 184.122 67.8186C184.473 68.6839 184.781 69.5661 185.044 70.4621C185.328 71.3652 185.542 72.2954 185.741 73.2373C186.12 75.1481 186.348 77.0856 186.422 79.032C186.584 83.0411 186.145 87.0518 185.118 90.9315C184.065 94.9768 182.323 98.8118 179.966 102.269C181.783 101.023 183.421 99.5347 184.834 97.8464C186.282 96.1339 187.531 94.2626 188.554 92.2688C190.63 88.2026 191.917 83.7829 192.348 79.2413C192.828 74.5603 192.332 69.8311 190.893 65.3496C190.686 64.7798 190.504 64.2061 190.258 63.6402C190.013 63.0743 189.784 62.5123 189.507 61.958C188.954 60.8482 188.323 59.7784 187.62 58.7564C186.229 56.7437 184.58 54.9196 182.717 53.3299C180.866 51.7419 178.822 50.3904 176.635 49.3066C174.427 48.2177 172.085 47.4215 169.669 46.9383C167.225 46.4689 164.723 46.3683 162.249 46.6398C161.02 46.7868 159.804 47.0239 158.61 47.3491C157.437 47.6738 156.29 48.0858 155.178 48.5817C154.095 49.0615 153.047 49.6172 152.042 50.2446C151.05 50.8519 150.093 51.5158 149.178 52.233C148.275 52.9423 147.415 53.6865 146.598 54.4423C146.189 54.8299 145.796 55.2175 145.407 55.6051L144.831 56.1827L144.244 56.7873C143.465 57.6168 142.738 58.4657 142.053 59.3494C141.368 60.2332 140.734 61.1518 140.158 62.0975C138.995 63.959 138.049 65.946 137.337 68.0202Z",
    fill: "#3E84C5",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.693 153.763C130.788 155.546 129.192 157.631 127.969 159.933C126.727 162.216 125.78 164.646 125.152 167.166C124.509 169.699 124.208 172.306 124.257 174.918C124.267 177.529 124.742 180.117 125.662 182.562C126.327 180.015 126.767 177.589 127.304 175.197C127.841 172.806 128.343 170.461 128.927 168.123C129.51 165.786 130.133 163.472 130.791 161.096L131.779 157.511C132.102 156.282 132.433 155.057 132.693 153.763Z",
    fill: "#3E84C5",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.417 86.0288C139.417 86.0288 135.468 106.417 145.06 109.227C154.652 112.037 159.629 105.576 159.629 105.576",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.754 86.2571C148.754 86.6447 147.54 89.6021 146.638 92.7456C146.585 92.9227 146.577 93.1097 146.611 93.2909C146.646 93.4722 146.724 93.6426 146.838 93.788C146.952 93.9334 147.099 94.0498 147.267 94.1273C147.436 94.2049 147.62 94.2414 147.805 94.234C148.906 94.1681 150.276 93.9045 150.918 93.0441",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.064 77.5939C137.064 77.5939 164.634 67.1286 164.202 57.3687",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.194 61.3918C163.194 61.3918 165.918 73.0549 169.506 76.2875",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.984 52.198C175.12 48.4498 165.785 45.4769 156.574 48.0622C147.364 50.6475 143.013 57.1089 138.032 64.9928C135.019 69.8094 133.195 75.2688 132.709 80.9234C132.709 80.9234 132.32 87.4662 136.725 89.2104",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.881 54.2681C180.881 54.2681 181.009 52.3301 183.823 54.2681C186.636 56.2061 192.045 63.8303 192.773 75.4624C194.115 96.8543 177.422 105.188 176.655 105.575",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.148 80.2764C175.148 78.2609 177.499 75.6252 179.46 76.1407C181.966 76.8035 182.184 82.2028 182.207 82.9276C182.254 84.1137 182.445 88.9006 178.818 92.0402C177.486 93.1746 175.874 93.9334 174.148 94.238",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M173.832 99.6333C173.498 102.734 169.941 108.978 172.696 116.045C174.528 120.733 177.366 124.966 181.012 128.448",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.652 114.064C152.734 115.289 155.894 119.684 152.652 127.696",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M146.205 129.665C141.358 130.406 136.719 132.146 132.585 134.774C124.503 139.995 124.118 145.328 112.37 168.336C105.817 181.174 110.312 180.833 115.724 182.453L124.881 184.422",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M143.66 136.859C143.392 143.126 155.054 154.987 155.361 162.534",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.291 183.666C111.29 184.502 110.973 185.306 110.402 185.917C109.831 186.529 109.049 186.903 108.213 186.965C105.693 187.158 103.19 186.417 101.185 184.883C92.0587 177.887 84.1023 169.495 77.6118 160.019",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6241 163.472C78.0175 175.612 84.909 185.383 90.4036 192.686C97.0188 201.453 101.358 206.384 107.113 206.271C111.487 206.186 114.989 203.225 117.172 200.845",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8841 151.41C69.1292 150.313 68.8918 149.27 68.4482 147.328L62.8292 142.677C62.7397 142.599 62.6541 142.518 62.5684 142.433C61.7435 141.561 58.8055 139.06 59.3348 138.378C60.2687 137.173 67.1407 140.909 70.2304 142.797C73.4135 144.735 75.3514 145.937 76.5927 148.46C78.2465 151.817 77.5189 155.204 77.1647 156.499",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M155.361 162.535C161.222 151.945 172.183 142.612 180.655 134.038C183.27 131.39 187.387 131.662 191.095 132.057C197.422 132.735 204.427 139.189 207.209 171.593",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176.58 46.7986C176.556 45.4652 176.58 39.6938 180.031 37.4961C185.849 33.7828 198.118 42.3489 197.301 47.9614C196.768 51.6398 190.686 53.6708 188.285 54.3569",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.693 154.135C132.172 154.654 130.382 160.554 128.549 166.953C125.463 177.729 124.041 188.91 124.331 200.113L124.926 222.71",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5723 161.642C67.5723 161.642 54.1045 158.658 53.4818 158.495C50.5439 157.72 48.5555 151.603 46.4036 149.266C41.1854 143.595 44.7537 144.134 48.4193 147.832C51.5323 150.968 58.5172 156.193 58.4549 156.007C58.3927 155.82 53.7192 150.77 51.6958 148.301C42.9053 137.56 44.7731 134.812 53.0694 145.902C55.4898 149.13 60.9454 152.797 60.9454 152.712C60.9454 152.627 57.0541 146.429 54.4275 143.603C45.9094 134.409 50.9253 135.545 56.9879 141.704C60.0387 144.805 67.1364 152.061 67.1364 151.848",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M178.328 120.436C183.124 124.519 186.442 130.055 187.776 136.196C189.983 146.661 185.379 154.801 184.274 156.662",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M170.304 169.759C168.619 169.131 167.821 168.344 167.58 167.495C166.413 163.131 179.328 153.313 183.955 156.212C188.581 159.111 185.344 174.988 180.768 175.91C180.149 176.034 179.355 175.91 178.347 175.232",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M142.839 132.696C141.372 135.188 137.352 142.774 138.882 152.502C139.518 156.478 140.976 160.279 143.162 163.665",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.807 163.677C146.554 163.581 149.002 165.74 148.652 167.836C148.231 170.344 144.223 171.069 142.663 170.244C139.947 168.798 141.048 163.875 144.807 163.677Z",
    stroke: "#615F5F",
    strokeWidth: 0.716122,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1227_6929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7286 141.06C58.8976 140.949 59.7073 142.085 63.3388 144.212C69.3623 147.747 70.8496 146.793 73.1178 149.562C77.7862 155.035 75.5429 160.455 69.2301 163.064C61.4673 166.307 52.8286 162.101 50.3208 153.533C49.8209 151.653 48.7261 147.542 51.1471 144.254C51.7917 143.352 52.6241 142.6 53.5874 142.049C54.5508 141.498 55.6222 141.161 56.7286 141.06Z",
    fill: "#407DBB"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0723 102.269L58.0723 131.791",
    stroke: "#50555A",
    strokeOpacity: 0.5,
    strokeWidth: 0.965507,
    strokeLinecap: "round",
    strokeDasharray: "1.93 1.93"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6875 95.7256L66.6875 131.791",
    stroke: "#50555A",
    strokeOpacity: 0.5,
    strokeWidth: 0.965507,
    strokeLinecap: "round",
    strokeDasharray: "1.93 1.93"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19905 82.3891C3.41277 82.3891 2.65869 82.0528 2.10271 81.4541C1.54672 80.8555 1.23438 80.0435 1.23438 79.1969V5.36991C1.23438 4.52329 1.54672 3.71135 2.10271 3.1127C2.65869 2.51405 3.41277 2.17773 4.19905 2.17773",
    stroke: "#615F5F",
    strokeWidth: 0.72413,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M125.01 54.0233V78.9303C125.01 79.7769 124.698 80.5888 124.142 81.1875C123.586 81.7861 122.831 82.1224 122.045 82.1224H13.1133",
    stroke: "#615F5F",
    strokeWidth: 0.72413,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6445 0.620117H122.044C122.83 0.620117 123.585 0.956436 124.141 1.55508C124.697 2.15373 125.009 2.96567 125.009 3.81229V44.5338",
    stroke: "#615F5F",
    strokeWidth: 0.72413,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5937 97.1402L66.6889 94.2354L63.784 97.1402",
    stroke: "#A7AAAD",
    strokeWidth: 0.965507,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9766 102.417L58.0717 99.5122L55.1668 102.417",
    stroke: "#A7AAAD",
    strokeWidth: 0.965507,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M112.652 7.6886H21.2217C19.9526 7.6886 18.9238 8.24103 18.9238 8.9225V37.4594C18.9238 38.1409 19.9526 38.6933 21.2217 38.6933H112.652C113.921 38.6933 114.95 38.1409 114.95 37.4594V8.9225C114.95 8.24103 113.921 7.6886 112.652 7.6886Z",
    fill: "#4F95D0",
    fillOpacity: 0.03
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9238 23.7524H114.95",
    stroke: "#50555A",
    strokeOpacity: 0.5,
    strokeWidth: 0.482754,
    strokeDasharray: "0.97 0.97"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.372,
    cy: 23.2067,
    rx: 4.87782,
    ry: 10.0341,
    fill: "#407DBB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.3027,
    cy: 24.1729,
    rx: 2.9453,
    ry: 4.77205,
    fill: "#407DBB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.6348,
    cy: 24.1737,
    rx: 2.9453,
    ry: 6.46762,
    fill: "#407DBB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2305,
    cy: 24.1737,
    rx: 2.9453,
    ry: 6.46762,
    fill: "#407DBB"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.5625,
    cy: 24.1735,
    rx: 2.9453,
    ry: 10.4285,
    fill: "#407DBB"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.2176,
    ry: 4.31117,
    transform: "matrix(-1 0 0 1 76.6242 24.1729)",
    fill: "#407DBB"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.32099,
    ry: 4.31117,
    transform: "matrix(-1 0 0 1 83.6048 24.1729)",
    fill: "#407DBB"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.39172,
    ry: 4.31117,
    transform: "matrix(-1 0 0 1 91.0223 24.1729)",
    fill: "#407DBB"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.00413,
    ry: 2.3659,
    transform: "matrix(-1 0 0 1 94.5603 24.2425)",
    fill: "#407DBB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M112.652 45.874H21.2217C19.9526 45.874 18.9238 46.4265 18.9238 47.1079V75.6449C18.9238 76.3263 19.9526 76.8788 21.2217 76.8788H112.652C113.921 76.8788 114.95 76.3263 114.95 75.6449V47.1079C114.95 46.4265 113.921 45.874 112.652 45.874Z",
    fill: "#4F95D0",
    fillOpacity: 0.03
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9238 61.9385H107.686",
    stroke: "#50555A",
    strokeOpacity: 0.5,
    strokeWidth: 0.482754,
    strokeDasharray: "0.97 0.97"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.3786,
    cy: 61.3926,
    rx: 3.35521,
    ry: 8.61505,
    fill: "#F2C94C"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.6092,
    cy: 62.3587,
    rx: 2.72251,
    ry: 4.77205,
    fill: "#F2C94C"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.2577,
    cy: 62.359,
    rx: 2.72251,
    ry: 6.46762,
    fill: "#F2C94C"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.9588,
    cy: 62.3592,
    rx: 2.72251,
    ry: 10.4285,
    fill: "#F2C94C"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.06978,
    ry: 4.31117,
    transform: "matrix(-1 0 0 1 78.7115 62.3595)",
    fill: "#F2C94C"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.28645,
    ry: 4.31117,
    transform: "matrix(-1 0 0 1 85.5671 62.3595)",
    fill: "#F2C94C"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.928176,
    ry: 2.3659,
    transform: "matrix(-1 0 0 1 88.8374 62.4284)",
    fill: "#F2C94C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1227_6929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9698,
    height: 23.0903,
    fill: "white",
    transform: "matrix(-1 0 0 1 75.5938 141.052)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer_icon.560060fc52a4533016cd6c78a9d22523.svg";
export { ForwardRef as ReactComponent };